import router from '@/router'
import {
  DISPLAY_SHOP_SIDEBAR,
  LOAD_SHOP_DETAILS,
  SET_SHOP_DETAILS,
  UPDATING_SHOP,
  ENABLE_DISABLE_SHOP,
  LOAD_PUBLIC_STORE,
  SET_PUBLIC_STORE,
  SET_PUBLIC_STORE_PRODUCTS,
  LOAD_STORE_PRODUCT_DETAILS,
  SET_STORE_PRODUCT,
  SET_STORE_PRODUCT_VARIANTS,
  SET_STORE_VARIANTS_IMAGES,
  SET_STORE_VARIANT_DICTIONARY,
  SET_STORE_VARIANT_TYPES,
  SET_STORE_VARIANT_COLORS,
  SET_STORE_VARIANT_SIZES,
  PRODUCT_STORE_NOT_FOUND,
  UPDATE_STORE_VARIANT_SIZES,
  UPDATE_STORE_VARIANT_COLORS,
  LOAD_SUGGESTED_STORE_PRODUCTS,
  SET_SUGGESTED_STORE_PRODUCTS,
  SHOW_ADD_TO_CART_NOTIFICATION,
  HIDE_ADD_TO_CART_NOTIFICATION,
  LOAD_STORE_CART,
  SET_STORE_CART,
  IS_ADDING_ITEM_TO_CART,
  ADD_ITEM_TO_CART,
  IS_REMOVING_CART_ITEM,
  IS_UPDATING_CART_ITEM,
  IS_SETTING_SHIPPING_ADDRESS,
  ROLL_UP_SHIPPING_ADDRESS,
  ROLL_DOWN_FORM_BILLING_ADDRESS,
  SET_PAYMENT_DETAILS,
  CREATING_PAYMENT_INTENT,
  SET_PAYMENT_CLIENT_SECRET,
  CONNECTING_STRIPE,
  CREATING_STORE,
  SET_STRIPE_BLOB,
  SET_LOADING_SHOP_STAT,
  SET_SHOP_STATS,
  SET_LOADING_SHOP_ORDERS,
  SET_SHOP_ORDERS,
  SET_EXPORTING_PAYOUT,
  SET_EXPORTING_ORDER,
  SET_STORE_PRODUCTS,
  SET_PRODUCT_ATTRIBUTES,
  RESET_PRODUCT_ATTRIBUTES,
  SET_LOADING_PRODUCTS,
  SET_LOADING_CHECK_DNS,
  SET_DNS_STATUS,
  SET_UPDATING_PRODUCT_VARIANTS,
  SET_SELECTED_PRODUCT_VARIANTS,
  SET_ECOM_PRODUCT_VARIANTS,
  SET_PRODUCT_DEFAULT_IMAGE,
  SELECT_ALL_GIFT_CARDS,
  SET_SELECTED_GIFT_CARDS,
  CREATING_GIFT_CARD,
  DELETING_GIFT_CARD,
  RESET_SELECTED_GIFT_CARDS,
  FETCHING_GIFT_CARDS,
  SET_GIFT_CARDS,
  SET_GIFT_CARDS_TOTAL_COUNT
} from '@/state/mutationTypes'
import api, { getData } from '@/axiosConfig'
const gemnoteAPI = api()

import { defaultNoTrendingImage, status } from '../../helpers'
import i18n from '../../internatinalization/i18n'
import requestErrorHandler from '@/utils/request-error-handler'
import {
  SET_LOADING_ORDER,
  SET_LOADING_PRODUCT_IMAGES,
  SET_CREATING_PRODUCT_IMAGES,
  SET_LOADING_PAYOUTS,
  SET_ORDER,
  SET_SHOP_PAYOUTS
} from '../mutationTypes'

export default {
  displayShopSideBar({ commit }, newState) {
    commit(DISPLAY_SHOP_SIDEBAR, newState)
  },
  async getStoreDetails({ commit, dispatch }) {
    try {
      commit(LOAD_SHOP_DETAILS, true)
      const response = await gemnoteAPI.get('store')
      const data = getData(response)

      if (data) {
        let shopDetails = {
          id: data.id,
          ...data.attributes,
          status: data.attributes.status === 'inactive' ? false : true,
          primaryColor: data.attributes.primaryColor
            ? data.attributes.primaryColor
            : '#25282a',
          favicon: { url: '' }
        }
        commit(SET_SHOP_DETAILS, shopDetails)
      }
      commit(LOAD_SHOP_DETAILS, false)
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.get-shop-details-error')]
          },
          { root: true }
        )
      }
    }
  },
  async getDashboardStats(
    { commit },
    payload = { time_period: 'last_7_days', start_date: null, end_date: null }
  ) {
    try {
      commit(SET_LOADING_SHOP_STAT, true)
      let url = `carts/metrics`
      if (payload.time_period) {
        url += `?time_period=${payload.time_period}`
      } else if (payload.start_date && payload.end_date) {
        url += `?start_date=${payload.start_date}&end_date=${payload.end_date}`
      }
      const response = await gemnoteAPI.get(url)
      const data = response.data
      if (data) {
        commit(SET_SHOP_STATS, data)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(SET_LOADING_SHOP_STAT, false)
    }
  },
  async exportPayouts({ commit }, exportHandler) {
    try {
      commit(SET_EXPORTING_PAYOUT, true)
      const response = await gemnoteAPI.get('payouts/summary_csv')
      const data = response.data
      if (data) {
        exportHandler(data)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(SET_EXPORTING_PAYOUT, false)
    }
  },
  async exportOrders({ commit }, exportHandler) {
    try {
      commit(SET_EXPORTING_ORDER, true)
      const response = await gemnoteAPI.get('carts/summary_csv')
      const data = response.data
      if (data) {
        exportHandler(data)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(SET_EXPORTING_ORDER, false)
    }
  },
  async getOrderList(
    { commit },
    payload = {
      page: 1,
      perPage: 10,
      time_period: 'last_7', // 7 days default
      startDate: null,
      endDate: null
    }
  ) {
    try {
      commit(SET_LOADING_SHOP_ORDERS, true)

      let url = `carts?page=${payload.page}&perPage=${payload.perPage}`
      if (payload.time_period) {
        url += `&time_period=${payload.time_period}`
      } else {
        if (payload.startDate && payload.endDate) {
          url += `&start_date=${payload.startDate}&end_date=${payload.endDate}&filter=date_range`
        }
      }
      const response = await gemnoteAPI.get(url)

      const data = response.data
      if (data) {
        commit(SET_SHOP_ORDERS, {
          orders: data.data,
          metrics: data.meta.metrics,
          pagination: data.meta
        })
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(SET_LOADING_SHOP_ORDERS, false)
    }
  },
  async searchOrders({ commit }, payload = { page: 1 }) {
    try {
      commit(SET_LOADING_SHOP_ORDERS, true)
      const response = await gemnoteAPI.get(
        `carts/search?query=${payload.query}`
      )
      const data = response.data
      if (data) {
        commit(SET_SHOP_ORDERS, {
          orders: data.data,
          pagination: data.meta
        })
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(SET_LOADING_SHOP_ORDERS, false)
    }
  },
  async getOrderDetails({ commit }, payload) {
    try {
      commit(SET_LOADING_ORDER, true)
      const response = await gemnoteAPI.get(`/cart_details/${payload.order_id}`)
      const data = response.data
      if (data) {
        commit(SET_ORDER, data.data)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(SET_LOADING_ORDER, false)
    }
  },
  async getShopPayouts({ commit }, payload = { page: 1, perPage: 10 }) {
    try {
      commit(SET_LOADING_PAYOUTS, true)
      const response = await gemnoteAPI.get(
        `/payouts?page=${payload.page}&perPage=${payload.perPage}`
      )
      const data = response.data
      if (data) {
        commit(SET_SHOP_PAYOUTS, {
          payouts: data.data,
          metrics: data.meta.metrics,
          pagination: data.meta
        })
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(SET_LOADING_PAYOUTS, false)
    }
  },
  async createStore({ commit, dispatch }, storeData) {
    try {
      commit(CREATING_STORE, status.LOADING)
      const response = await gemnoteAPI.post('/store', storeData)
      const data = getData(response)
      let shopDetails = {
        id: data.id,
        ...data.attributes,
        status: data.attributes.status === 'inactive' ? false : true,
        primaryColor: data.attributes.primaryColor
          ? data.attributes.primaryColor
          : '#25282a'
      }
      commit(SET_SHOP_DETAILS, shopDetails)
      commit(CREATING_STORE, status.LOADING)

      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('ecommerce.action.update-store-success')]
        },
        { root: true }
      )
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('ecommerce.connecting-stripe')]
        },
        { root: true }
      )
      dispatch('ecommerce/connectStripe')
    } catch (error) {
      commit(CREATING_STORE, status.ERROR)
      requestErrorHandler(error, i18n.t('ecommerce.action.update-store-error'))
    }
  },
  async checkDNS({ commit, dispatch }) {
    try {
      commit(SET_LOADING_CHECK_DNS, status.LOADING)
      const response = await gemnoteAPI.post('/store/check_dns_status')
      const data = response.data
      if (data.domain_verified) {
        dispatch('getStoreDetails')
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('ecommerce.action.domain-connected')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.domain-not-connected')]
          },
          { root: true }
        )
      }
      commit(SET_DNS_STATUS, data)
      commit(SET_LOADING_CHECK_DNS, status.LOADING)
    } catch (error) {
      commit(CREATING_STORE, status.ERROR)
      requestErrorHandler(error)
    }
  },
  async editStore({ commit, dispatch }, storeData) {
    const shouldNotify = storeData.get('shouldNotify')
    storeData.delete('shouldNotify')
    try {
      commit(UPDATING_SHOP, status.LOADING)
      const response = await gemnoteAPI({
        method: 'PATCH',
        url: 'store',
        data: storeData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
      const data = getData(response)
      let shopDetails = {
        id: data.id,
        ...data.attributes,
        status: data.attributes.status === 'inactive' ? false : true,
        primaryColor: data.attributes.primaryColor
          ? data.attributes.primaryColor
          : '#25282a'
      }
      commit(SET_SHOP_DETAILS, shopDetails)
      commit(UPDATING_SHOP, status.LOADED)
      if (shouldNotify === 'true') {
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('ecommerce.action.update-store-success')]
          },
          { root: true }
        )
      }
    } catch (error) {
      commit(UPDATING_SHOP, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.update-store-error')]
          },
          { root: true }
        )
      }
    }
  },
  async updateStripe({ commit, dispatch }, stripeData) {
    try {
      commit(UPDATING_SHOP, status.LOADING)
      const response = await gemnoteAPI.patch(
        `/store_front/${stripeData.store_slug}`,
        {
          account_id: stripeData.account_id
        }
      )
      const data = getData(response)
      if (!data.attributes.stripeAccountBlob.verification.disabledReason) {
        commit(SET_STRIPE_BLOB, data.attributes.stripeAccountBlob)
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('ecommerce.action.stripe-connected-success')]
          },
          { root: true }
        )
      }
      commit(UPDATING_SHOP, status.LOADED)
    } catch (error) {
      commit(UPDATING_SHOP, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.stripe-connected-error')]
          },
          { root: true }
        )
      }
    }
  },

  async enableDisableStore({ state, commit, dispatch }) {
    try {
      commit(ENABLE_DISABLE_SHOP, true)
      let { shopDetails } = state
      let response
      if (shopDetails.status) {
        response = await gemnoteAPI.post('store/disable_store')
      } else {
        response = await gemnoteAPI.post('store/enable_store')
      }
      const data = getData(response)
      shopDetails = {
        id: data.id,
        ...data.attributes,
        status: data.attributes.status === 'inactive' ? false : true,
        primaryColor: data.attributes.primaryColor
          ? data.attributes.primaryColor
          : '#25282a'
      }
      commit(SET_SHOP_DETAILS, shopDetails)
      commit(ENABLE_DISABLE_SHOP, false)
    } catch (error) {
      console.log(error)
      commit(ENABLE_DISABLE_SHOP, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.enable-disable-store-error')]
          },
          { root: true }
        )
      }
    }
  },

  //Ecommerce  Products
  async getProductImages({ commit }, payload) {
    try {
      commit(SET_LOADING_PRODUCT_IMAGES, true)
      const response = await gemnoteAPI.get(
        `/products/${payload.id}/attachments`
      )

      const data = response.data

      if (data) {
        let productImageDetails = {
          defaultECommerceImageId: data.data.attributes.defaultECommerceImageId,
          images: data.data.attributes.images,
          variants: data.data.attributes.productVariantImages
        }
        commit(SET_PRODUCT_ATTRIBUTES, productImageDetails)
        commit(SET_PRODUCT_DEFAULT_IMAGE, {
          ...productImageDetails,
          product_id: payload.id
        })
        return productImageDetails
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(SET_LOADING_PRODUCT_IMAGES, false)
    }
  },
  async getStoreProductVariants({ state, commit }, payload) {
    let { shopDetails } = state

    try {
      const response = await gemnoteAPI.get(
        `/store_front/${shopDetails.slug}/products/${payload}/product_variants`
      )

      const data = response.data

      if (data) {
        commit(SET_ECOM_PRODUCT_VARIANTS, data)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(SET_LOADING_PRODUCT_IMAGES, false)
    }
  },
  async updateProductImages({ state, commit, dispatch }, payload) {
    try {
      commit(SET_UPDATING_PRODUCT_VARIANTS, true)
      let { productAttributes, selectedProductVariants } = state
      let product = {
        default_e_commerce_image_id: productAttributes.defaultECommerceImageId,
        product_variants: selectedProductVariants
      }
      const response = await gemnoteAPI.patch(
        `/products/${payload.id}/attachments`,
        { product }
      )

      const data = response.data

      if (data) {
        let productImageDetails = {
          defaultECommerceImageId: data.data.attributes.defaultECommerceImageId,
          images: data.data.attributes.images,
          variants: data.data.attributes.productVariantImages
        }
        commit(SET_PRODUCT_ATTRIBUTES, productImageDetails)
        commit(SET_SELECTED_PRODUCT_VARIANTS, null)
        commit(SET_PRODUCT_DEFAULT_IMAGE, {
          ...productImageDetails,
          product_id: payload.id
        })
      }

      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: ['Product Variants  updated successfully']
        },
        { root: true }
      )
      dispatch('modal/hideModal', {}, { root: true })
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(SET_UPDATING_PRODUCT_VARIANTS, false)
    }
  },

  async resetProductImages({ commit }) {
    commit(RESET_PRODUCT_ATTRIBUTES, false)
  },

  async createProductImages({ commit, dispatch }, { product_id, formData }) {
    try {
      commit(SET_CREATING_PRODUCT_IMAGES, true)
      const response = await gemnoteAPI.post(
        `/products/${product_id}/attachments`,
        formData
      )
      const data = response.data

      if (data) {
        // console.log(data)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      commit(SET_CREATING_PRODUCT_IMAGES, false)
      dispatch('getProductImages', { id: product_id })
    }
  },

  async deleteProductImage({ commit, dispatch }, { product_id, image_id }) {
    try {
      // commit(SET_LOADING_PRODUCT_IMAGES, true)
      const response = await gemnoteAPI.delete(
        `/products/${product_id}/attachments/${image_id}`
      )
      const data = response.data

      if (data) {
        let productImageDetails = {
          defaultECommerceImageId: data.data.attributes.defaultECommerceImageId,
          images: data.data.attributes.images,
          variants: data.data.attributes.productVariantImages
        }
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: ['Product Image deleted.']
          },
          { root: true }
        )
        commit(SET_PRODUCT_ATTRIBUTES, productImageDetails)
      }
    } catch (error) {
      requestErrorHandler(error)
    } finally {
      // commit(SET_LOADING_PRODUCT_IMAGES, false)
    }
  },

  // public store action services
  async getPublicStore({ commit, dispatch }, { storeId }) {
    try {
      commit(LOAD_PUBLIC_STORE, status.LOADING)
      const response = await gemnoteAPI.get(`store_front/${storeId}`)
      // header token
      if (!window.$cookies.isKey('public-store-token')) {
        window.$cookies.set(
          'public-store-token',
          response.headers['recipient-token']
        )
      }
      const data = getData(response)
      let publicStore = {
        id: data.id,
        storeId,
        title: data.attributes.title,
        description: data.attributes.description,
        primaryColor: data.attributes.primaryColor,
        status: data.attributes.status,
        paigeTeamId: data.attributes.paigeTeamId,
        storeLogo: data.attributes.logoImage
          ? data.attributes.logoImage.url
          : '',
        bannerImage: data.attributes.bannerImage
          ? data.attributes.bannerImage.url
          : ''
      }
      commit(SET_PUBLIC_STORE, publicStore)
      // get products
      await dispatch('getStoreProducts', storeId)
      // get cart
      await dispatch('getStoreCart', storeId)

      commit(LOAD_PUBLIC_STORE, status.LOADED)
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
          commit(SET_PUBLIC_STORE, [])
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.get-public-store')]
          },
          { root: true }
        )
      }
    }
  },
  async getStoreProducts({ commit, dispatch }, storeId) {
    commit(SET_LOADING_PRODUCTS, true)
    try {
      const response = await gemnoteAPI.get(`store_front/${storeId}/products`)

      const data = getData(response)
      let products = data.map(product => {
        return {
          id: product.id,
          image: product.attributes.defaultProductVariantImages.length
            ? product.attributes.defaultProductVariantImages[0].url
            : product.attributes.images.length
            ? product.attributes.images[0].url
            : defaultNoTrendingImage,
          title: product.attributes.name,
          cost: product.attributes.retailPrice,
          category: 'Gift',
          adminOnly: product.attributes.adminOnly,
          description: product.attributes.description,
          defaultImageUrl: null
        }
      })

      commit(SET_STORE_PRODUCTS, products)

      // get attatchments and set default image
      for (let index = 0; index < products.length; index++) {
        const product = products[index]
        await dispatch('getProductImages', { id: product.id })
      }
    } catch (error) {
      console.log(error)
      requestErrorHandler(
        error,
        i18n.t('ecommerce.action.get-public-store-products')
      )
    } finally {
      commit(SET_LOADING_PRODUCTS, false)
    }
  },
  async getStoreProductDetails({ state, commit, dispatch }, { productId }) {
    try {
      commit(LOAD_STORE_PRODUCT_DETAILS, status.LOADING)
      let { publicStore, publicStoreProducts } = state
      let product = publicStoreProducts.find(p => p.id === productId)
      if (product) {
        commit(SET_STORE_PRODUCT, product)
        const response = await gemnoteAPI.get(
          `store_front/${publicStore.storeId}/products/${productId}/product_variants`
        )
        const data = getData(response)
        let productVariants = data.map(variant => {
          return {
            id: variant.id,
            ...variant.attributes
          }
        })
        commit(SET_STORE_PRODUCT_VARIANTS, productVariants)
        commit(SET_STORE_VARIANTS_IMAGES, productVariants)
        commit(SET_STORE_VARIANT_DICTIONARY, productVariants)
        commit(SET_STORE_VARIANT_TYPES)
        commit(SET_STORE_VARIANT_COLORS)
        commit(SET_STORE_VARIANT_SIZES)
        commit(PRODUCT_STORE_NOT_FOUND, false)
        commit(LOAD_STORE_PRODUCT_DETAILS, status.LOADED)
      } else {
        let response = await gemnoteAPI.get(
          `store_front/${publicStore.storeId}/products`
        )
        const data = getData(response)
        let products = data.map(product => {
          return {
            id: parseInt(product.id),
            ...product.attributes
          }
        })
        commit(SET_PUBLIC_STORE_PRODUCTS, products)
        let product = products.find(p => p.id === parseInt(productId))
        if (product) {
          commit(SET_STORE_PRODUCT, product)
          const response = await gemnoteAPI.get(
            `store_front/${publicStore.storeId}/products/${productId}/product_variants`
          )
          const data = getData(response)
          let productVariants = data.map(variant => {
            return {
              id: variant.id,
              ...variant.attributes
            }
          })
          commit(SET_STORE_PRODUCT_VARIANTS, productVariants)
          commit(SET_STORE_VARIANTS_IMAGES, productVariants)
          commit(SET_STORE_VARIANT_DICTIONARY, productVariants)
          commit(SET_STORE_VARIANT_TYPES)
          commit(SET_STORE_VARIANT_COLORS)
          commit(SET_STORE_VARIANT_SIZES)
          commit(PRODUCT_STORE_NOT_FOUND, false)
          commit(LOAD_STORE_PRODUCT_DETAILS, status.LOADED)
        } else {
          commit(PRODUCT_STORE_NOT_FOUND, true)
        }
      }
    } catch (error) {
      console.log(error)
      commit(LOAD_STORE_PRODUCT_DETAILS, status.LOADED)
      commit(PRODUCT_STORE_NOT_FOUND, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.get-store-product-details')]
          },
          { root: true }
        )
      }
    }
  },
  async getSuggestedProducts(
    { state, commit, dispatch },
    { suggestedProductId }
  ) {
    try {
      let { publicStore } = state
      commit(LOAD_SUGGESTED_STORE_PRODUCTS, status.LOADING)
      const response = await gemnoteAPI.get(
        `store_front/${publicStore.storeId}/products/${suggestedProductId}/suggested_products`
      )
      const data = getData(response)
      let suggestedProducts = data.map(product => {
        return {
          id: parseInt(product.id),
          ...product.attributes
        }
      })
      commit(SET_SUGGESTED_STORE_PRODUCTS, suggestedProducts)
      commit(LOAD_SUGGESTED_STORE_PRODUCTS, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_SUGGESTED_STORE_PRODUCTS, status.LOADED)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.get-suggested-products-error')]
          },
          { root: true }
        )
      }
    }
  },
  async updateStoreVariantSizes({ commit }, variantSizesNewState) {
    commit(UPDATE_STORE_VARIANT_SIZES, variantSizesNewState)
  },
  async updateStoreVariantColors({ commit }, variantColorsNewState) {
    commit(UPDATE_STORE_VARIANT_COLORS, variantColorsNewState)
  },
  async getStoreCart({ commit, dispatch }, storeId) {
    try {
      commit(LOAD_STORE_CART, status.LOADING)
      const response = await gemnoteAPI.get(`store_front/${storeId}/cart`)
      const data = getData(response)

      let shopCart = {
        id: data.id,
        state: data.attributes.status,
        cartLineItemsSize: data.attributes.cartLineItemsSize,
        shippingFee: data.attributes.shippingFee,
        subTotal: data.attributes.subTotal,
        tax: data.attributes.tax,
        total: data.attributes.total,
        cartItems: Object.keys(data.attributes.cartItems).length
          ? data.attributes.cartItems.map(item => {
              return {
                id: item.id,
                createdAt: item.created_at,
                price: item.price,
                productVariantAttributes: item.product_variant_attributes,
                quantity: item.quantity,
                totalPrice: item.total_price,
                updatedAt: item.updated_at
              }
            })
          : [],
        recipientShippingAddress: { ...data.attributes.recipientInfo }
      }

      commit(SET_STORE_CART, shopCart)
      if (shopCart.recipientShippingAddress) {
        commit(ROLL_UP_SHIPPING_ADDRESS, true)
      }

      commit(LOAD_STORE_CART, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_STORE_CART, status.LOADED)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.get-cart-store-error')]
          },
          { root: true }
        )
      }
    }
  },
  async addItemToCart({ state, commit, dispatch }, { variantId, quantity }) {
    try {
      let { publicStore } = state
      commit(IS_ADDING_ITEM_TO_CART, true)
      let body = {
        cart_line_item: {
          product_variant_id: variantId,
          quantity
        }
      }

      const response = await gemnoteAPI.post(
        `store_front/${publicStore.storeId}/cart/cart_line_items`,
        body
      )
      const data = getData(response)
      let cartItem = {
        id: data.id,
        createdAt: data.attributes.created_at,
        price: data.attributes.price,
        productVariantAttributes: data.attributes.productVariantAttributes,
        quantity: data.attributes.quantity,
        totalPrice: data.attributes.totalPrice,
        updatedAt: data.attributes.updatedAt
      }
      commit(ADD_ITEM_TO_CART, cartItem)
      commit(SHOW_ADD_TO_CART_NOTIFICATION)
      commit(IS_ADDING_ITEM_TO_CART, false)
      setTimeout(() => {
        commit(HIDE_ADD_TO_CART_NOTIFICATION)
      }, 4000)
      await dispatch('getStoreCart', publicStore.storeId)
    } catch (error) {
      console.log(error)
      commit(IS_ADDING_ITEM_TO_CART, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors[0].message
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.add-item-to-cart-error')]
          },
          { root: true }
        )
      }
    }
  },
  async removeCartItem({ state, commit, dispatch }, { itemId }) {
    try {
      let { publicStore } = state
      commit(IS_REMOVING_CART_ITEM, true)
      await gemnoteAPI.delete(
        `store_front/${publicStore.storeId}/cart/cart_line_items/${itemId}`
      )
      // refresh cart
      dispatch('getStoreCart', publicStore.storeId)
      commit(IS_REMOVING_CART_ITEM, false)
    } catch (error) {
      console.log(error)
      commit(IS_REMOVING_CART_ITEM, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors[0].message
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.remove-item-to-cart-error')]
          },
          { root: true }
        )
      }
    }
  },
  async updateCartItem({ state, commit, dispatch }, { itemId, quantity }) {
    try {
      commit(IS_UPDATING_CART_ITEM, true)
      let { publicStore } = state
      let body = {
        cart_line_item: {
          quantity
        }
      }
      await gemnoteAPI.patch(
        `store_front/${publicStore.storeId}/cart/cart_line_items/${itemId}`,
        body
      )
      commit(IS_UPDATING_CART_ITEM, false)
      await dispatch('getStoreCart', publicStore.storeId)
    } catch (error) {
      console.log(error)
      commit(IS_UPDATING_CART_ITEM, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors[0].message
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.remove-item-to-cart-error')]
          },
          { root: true }
        )
      }
    }
  },
  rollDownToEditShippingAddress({ commit }) {
    commit(ROLL_UP_SHIPPING_ADDRESS, false)
  },
  async setShippingAddress({ commit, dispatch, state }, shippingAddress) {
    try {
      let { publicStore } = state
      commit(IS_SETTING_SHIPPING_ADDRESS, true)
      let errors = []
      if (shippingAddress.country === '') {
        errors.push('Country is required.')
      }

      if (shippingAddress.name === '') {
        errors.push('Name is required.')
      }

      if (shippingAddress.address_one === '') {
        errors.push('Address Line 1 is required.')
      }

      if (shippingAddress.state === '') {
        errors.push('State is required.')
      }

      if (shippingAddress.zipcode === '') {
        errors.push('Postal Code is required.')
      }

      if (errors.length) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
        commit(IS_SETTING_SHIPPING_ADDRESS, false)
        return
      }
      let body = {
        recipient: {
          name: shippingAddress.name,
          company: shippingAddress.company,
          email: shippingAddress.email,
          phone: shippingAddress.phone,
          address_one: shippingAddress.addressOne,
          address_two: shippingAddress.addressTwo,
          city: shippingAddress.city,
          state: shippingAddress.state,
          zipcode: shippingAddress.zipcode,
          country: shippingAddress.country
        }
      }

      await gemnoteAPI.post(
        `store_front/${publicStore.storeId}/cart/finalize`,
        body
      )

      commit(ROLL_UP_SHIPPING_ADDRESS, true)
      commit(IS_SETTING_SHIPPING_ADDRESS, false)
    } catch (error) {
      console.log(error)
      commit(IS_SETTING_SHIPPING_ADDRESS, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('ecommerce.action.setting-shipping-address-error')
            ]
          },
          { root: true }
        )
      }
    }
  },
  displayFormAddNewBillingAddress({ commit }, newBillingAddress) {
    commit(ROLL_DOWN_FORM_BILLING_ADDRESS, newBillingAddress)
  },
  setPaymentMethodDetails({ commit }, paymentDetails) {
    commit(SET_PAYMENT_DETAILS, paymentDetails)
  },
  async createPaymentIntent({ commit, dispatch, state }) {
    try {
      let { publicStore } = state
      commit(CREATING_PAYMENT_INTENT, true)
      let response = await gemnoteAPI.post(
        `store_front/${publicStore.storeId}/cart/checkout`
      )

      const data = getData(response)
      let stripeClientSecret = {
        id: data.id,
        ...data.attributes
      }
      commit(SET_PAYMENT_CLIENT_SECRET, stripeClientSecret)
      commit(CREATING_PAYMENT_INTENT, false)
    } catch (error) {
      console.log(error)
      commit(IS_SETTING_SHIPPING_ADDRESS, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.creating-payment-intent-error')]
          },
          { root: true }
        )
      }
    }
  },

  // Gift Cards
  async getAllGiftCards({ commit, dispatch }, payload) {
    const requestParams = new URLSearchParams()

    Object.keys(payload).forEach(key => {
      if (key === 'filter' || key === 'sort') {
        const fields = Object.keys(payload[key])
        if (fields.length) {
          fields.forEach(field => {
            requestParams.append(`${key}[${field}]`, payload[key][field])
          })
        }
      }

      if (key === 'search' || key === 'page' || key === 'size') {
        requestParams.append(`${key}`, payload[key])
      }
    })

    try {
      commit(FETCHING_GIFT_CARDS, true)
      let response = await gemnoteAPI.get(
        `gift_card_recipients?${decodeURIComponent(requestParams.toString())}`
      )

      const data = getData(response)
      if (response.data.meta) {
        const { totalCount } = response.data.meta
        commit(SET_GIFT_CARDS_TOTAL_COUNT, totalCount)
      }
      const giftCards = data.map(card => {
        return {
          ...card,
          ...card.attributes
        }
      })
      commit(SET_GIFT_CARDS, giftCards)
      commit(FETCHING_GIFT_CARDS, false)
    } catch (error) {
      console.log(error)
      commit(FETCHING_GIFT_CARDS, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.creating-payment-intent-error')]
          },
          { root: true }
        )
      }
    }
  },
  async createGiftCards({ commit, dispatch }, payload) {
    try {
      commit(CREATING_GIFT_CARD, true)
      await gemnoteAPI.post(`gift_cards`, payload)

      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: ['Gift Card created successfully']
        },
        { root: true }
      )
      router.push('/e-commerce/gift-cards')
      commit(CREATING_GIFT_CARD, false)
    } catch (error) {
      console.log(error)
      commit(IS_SETTING_SHIPPING_ADDRESS, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.creating-payment-intent-error')]
          },
          { root: true }
        )
      }
    }
  },

  async resendGiftCards({ commit, dispatch }, payload) {
    try {
      commit(DELETING_GIFT_CARD, true)

      const response = await gemnoteAPI({
        method: 'POST',
        url: 'gift_card_recipients/bulk_resend_email',
        data: payload,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      })
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [response.data.message]
        },
        { root: true }
      )
      commit(DELETING_GIFT_CARD, false)
      commit(RESET_SELECTED_GIFT_CARDS)
      const requestParams = {
        filter: {},
        sort: {},
        search: '',
        page: 1,
        size: 10
      }

      await dispatch('getAllGiftCards', requestParams)
    } catch (error) {
      requestErrorHandler(
        error,
        'An error occurred while resending gift cards.'
      )
    }
  },

  async bulkDeleteGiftCards({ commit, dispatch }, payload) {
    try {
      commit(DELETING_GIFT_CARD, true)

      const response = await gemnoteAPI({
        method: 'DELETE',
        url: 'gift_card_recipients/bulk_delete',
        data: payload,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      })
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [response.data.message]
        },
        { root: true }
      )
      commit(DELETING_GIFT_CARD, false)
      commit(RESET_SELECTED_GIFT_CARDS)
      // const requestParams = {
      //   filter: {},
      //   sort: {},
      //   search: '',
      //   page: 1,
      //   size: 10
      // }
      //
      // await dispatch('getAllGiftCards', requestParams)
    } catch (error) {
      console.log(error)
      commit(IS_SETTING_SHIPPING_ADDRESS, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.creating-payment-intent-error')]
          },
          { root: true }
        )
      }
    }
  },
  async toggleGiftCard({ dispatch }, payload) {
    try {
      const { requestParams, cardDetails } = payload
      await gemnoteAPI({
        method: 'PATCH',
        url: `gift_card_recipients/${cardDetails.id}/toggle`,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      })
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: ['Gift card status updated successfully']
        },
        { root: true }
      )

      await dispatch('getAllGiftCards', requestParams)
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.creating-payment-intent-error')]
          },
          { root: true }
        )
      }
    }
  },

  async connectStripe({ commit, dispatch }) {
    try {
      commit(CONNECTING_STRIPE, true)
      const response = await gemnoteAPI.post('store/connect_stripe_account', {
        paige_url: window.location.href //'http://localhost:8080/e-commerce/details'
      })
      const data = getData(response)
      commit(CONNECTING_STRIPE, false)
      const stripeRedirectURL = data.attributes.stripeConnectAccountsLink.url
      window.open(stripeRedirectURL, '_blank').focus()
    } catch (error) {
      commit(CONNECTING_STRIPE, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('ecommerce.action.get-shop-details-error')]
          },
          { root: true }
        )
      }
    }
  },
  selectAllGiftCards({ commit }) {
    commit(SELECT_ALL_GIFT_CARDS)
  },
  setSelectedGiftCard({ commit }, payload) {
    commit(SET_SELECTED_GIFT_CARDS, payload)
  }
}
